module.exports = __webpack_public_path__ + "static/img/pirateFishing.1a7d253.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/pirateFishing.png
// module id = 1F9U
// module chunks = 0